import { onMounted, onUnmounted } from 'intact-vue-next';
import { isFunction } from 'intact-shared';
// @reference: Vue3.0
var getNow = Date.now;
// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
if (getNow() > document.createEvent('Event').timeStamp) {
  // if the low-res timestamp which is bigger than the event timestamp
  // (which is evaluated AFTER) it means the event is using a hi-res timestamp,
  // and we need to use the hi-res version for event listeners as well.
  getNow = function getNow() {
    return performance.now();
  };
}
// #3485: Firefox <= 53 has incorrect Event.timeStamp implementation
// and does not fire microtasks in between event propagation, so safe to exclude.
var ffMatch = navigator.userAgent.match(/firefox\/(\d+)/i);
var skipTimestampCheck = !!(ffMatch && Number(ffMatch[1]) <= 53);
export function useDocumentClick(ref, callback, manual) {
  if (manual === void 0) {
    manual = false;
  }
  var onDocumentClick = function onDocumentClick(e) {
    if (e._ignore) return;
    // https://github.com/ksc-fe/kpc/issues/788
    var timeStamp = e.timeStamp || getNow();
    if (!skipTimestampCheck && onDocumentClick.timeStamp > timeStamp + 1) {
      return;
    }
    var target = e.target;
    var elem = isFunction(ref) ? ref() : ref.value;
    if (containsOrEqual(elem, target)) return;
    callback(e);
  };
  var add = function add() {
    onDocumentClick.timeStamp = getNow();
    document.addEventListener('click', onDocumentClick);
    document.addEventListener('contextmenu', onDocumentClick);
  };
  var remove = function remove() {
    document.removeEventListener('click', onDocumentClick);
    document.removeEventListener('contextmenu', onDocumentClick);
  };
  if (!manual) {
    onMounted(add);
  }
  onUnmounted(remove);
  return [add, remove];
}
export function containsOrEqual(elem, target) {
  return target === elem || elem.contains(target);
}